// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import all from './all';
const baseUrl = 'http://localhost:4200';
export const environment = {
  ...all,
  oAuthConfig: {
    issuer: 'https://localhost:44322/',
    redirectUri: baseUrl,
    clientId: 'Insurance_App',
    responseType: 'code',
    grant_type: 'password',
    scope: 'offline_access Insurance',
  },
  production: false,
     apiUrl: 'https://api-qlbh.mbhxh.com.vn'
    //  apiUrl: 'https://uat-api.mbhxh.com.vn'
    //  apiUrl: 'https://localhost:44322',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frsames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
